import DataMgr from "@/Fwk/DataMgr";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ForcedLoginDialogFC} from "@/app/(pay)/UI/ForcedLoginDialog/ForcedLoginDialog";
import {VisitorRechargeDialogFC} from "@/app/(shop)/UI/VisitorRechargeDialog/VisitorRechargeDialog";
import UserGlobalMgr from "@/Core/UserGlobalMgr";
import {LoginUserType} from "@/Core/Login/types/user";
import Util from "@/Master/Util";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {ShopDialogFC} from "@/app/(shop)/ShopDialogFC";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import AuthTrack from "@/Core/AuthTrack";

export default class ShopMgr {


    static get getVisitorMobile(){
        const mobile = DataMgr.getStorage("visitorMobile");
        return mobile;
    }

    static get getVisitorAreaNo(){
        const areaNo = DataMgr.getStorage("visitorAreaNo");
        return areaNo;
    }

    static setVisitorMobile(mobile:string){
        DataMgr.setStorage("visitorMobile", mobile);
    }

    static setVisitorAreaNo(areaNo:string){
        DataMgr.setStorage("visitorAreaNo", areaNo);
    }

    static showVisitorMobileDialog(callMobileOK:()=>void){
        AuthTrack.showPhoneVerify()
        SDialogManagerFC.openDialog(VisitorRechargeDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(VisitorRechargeDialogFC),
            callMobileOK: () => {
                callMobileOK();
            }
        });
    }

    static showForcedLoginDialog(fn?: () => void){
        SDialogManagerFC.openDialog(ForcedLoginDialogFC,{
            fcKey:SDialogManagerFC.getFCKey(ForcedLoginDialogFC),
            onClose:()=>{
                fn && fn()
            }
        });
    }

    static hideForcedLoginDialog(){
        SDialogManagerFC.closeDialogFC(ForcedLoginDialogFC);
    }

    //校验用户是否强制去注册。
    static checkShowRegDialog(){
        const pathname = Util.pathname;
        //在登陆页面不进行弹窗显示
        const hasLogin = pathname.indexOf('login') !== -1;
        if (hasLogin) return;
        //忘记密码页面
        const hasForgot = pathname.indexOf('forgot') !== -1;
        if (hasForgot) return;
        const hasSignup = pathname.indexOf('signup') !== -1;
        if (hasSignup) return;
        //以及有用户帐号 不再校验
        if (LoginUIManager.getLastUserAccount){
            return;
        }
        if (ShopMgr.getVisitorMobile){//验证手机号是否有问题
            const globalInfo = UserGlobalMgr.getTempUserInfo;
            if (globalInfo.baseInfo.vipExp > 0 && globalInfo.loginType !== LoginUserType.normal){
                //验证是否充值过，正常值允许首次充值
                ShopMgr.showForcedLoginDialog();
                // RouterMgr.signup();
            }else{
                ShopMgr.hideForcedLoginDialog();
            }
        }
    }

    static hasUserFistPay(call:(ok:boolean)=>void){
        //以及有用户帐号 不再校验
        if (LoginUIManager.getLastUserAccount){
            return;
        }
        if (ShopMgr.getVisitorMobile){//验证手机号是否有问题
            const globalInfo = UserGlobalMgr.getTempUserInfo;
            if (globalInfo.baseInfo.vipExp > 0 && globalInfo.loginType !== LoginUserType.normal){
                //验证是否充值过，正常值允许首次充值
                call(true)
            }else{
                call(false)
            }
        }
    }


    static showShopDialog(){
        SDialogManagerFC.openDialog(ShopDialogFC,{
            fcKey:SDialogManagerFC.getFCKey(ShopDialogFC),
            onClose:(isOk:boolean)=>{
                GameMsgUtil.sendMsgLowerBackToGame();
            }
        })
    }

}